import React from 'react';
import { motion } from 'framer-motion';
import { Download, BookOpen, MessageSquareQuote, Clock, Infinity } from 'lucide-react';
const downloads = [{
  icon: BookOpen,
  title: 'THE "VOICES OF FREEDOM" EBOOK (High-Definition PDF)',
  desc: '144 pages of history, strategy, and courage. Compatible with Kindle, iPad, Android, and PC.',
  value: '$29'
}, {
  icon: MessageSquareQuote,
  title: 'THE "WAR CRY" QUOTE COMPENDIUM (E-Guide)',
  desc: 'The exact phrases to win any cultural debate, optimized for quick mobile reading.',
  value: '$12'
}, {
  icon: Clock,
  title: 'DIGITAL APPENDIX: INTERACTIVE TIMELINE',
  desc: "Charlie's life in key data points, from Arlington Heights to his final breath.",
  value: '$9'
}, {
  icon: Infinity,
  title: 'LIFETIME ACCESS',
  desc: 'Free future updates and multi-platform access. Your purchase never expires.',
  value: 'INCLUDED'
}];
export function AgitationSection() {
  return <section className="py-14 sm:py-24 px-4 relative" data-id="element-10">
      <div className="max-w-4xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 sm:mb-16" data-id="element-12">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6" data-id="element-13">
            WHAT YOU'RE DOWNLOADING{' '}
            <span className="text-brand-red" data-id="element-14">EXACTLY</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-15">
            When you complete your order of{' '}
            <span className="text-brand-gold font-bold font-oswald text-2xl" data-id="element-16">
              $17
            </span>
            , you'll receive immediate access to your{' '}
            <strong className="text-white" data-id="element-17">Private Members Area</strong> to
            download:
          </p>
        </motion.div>

        <div className="space-y-3 sm:space-y-6" data-id="element-18">
          {downloads.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="flex items-start gap-3 sm:gap-5 bg-white/5 p-4 sm:p-6 rounded-lg border border-white/10 hover:border-brand-gold/30 transition-colors" data-id="element-19">
                <div className="mt-1 bg-brand-gold/10 p-2 sm:p-3 rounded-lg border border-brand-gold/20 flex-shrink-0" data-id="element-20">
                  <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-brand-gold" data-id="element-21" />
                </div>
                <div className="flex-1" data-id="element-22">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-2" data-id="element-23">
                    <h3 className="text-base sm:text-xl font-bold text-white font-oswald tracking-wide" data-id="element-24">
                      {item.title}
                    </h3>
                    <span className="text-brand-gold font-bold text-sm font-oswald whitespace-nowrap" data-id="element-25">
                      Value: {item.value}
                    </span>
                  </div>
                  <p className="text-gray-400 text-sm sm:text-base" data-id="element-26">
                    {item.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}